import styled from 'styled-components';
import { Expander as VendorExpander } from 'app/components';
import { textTransform } from 'utils';

export const CinemaRentWrapper = styled.div.attrs({
  className: 'cinema-rent'
})`
  .cinema-rent__subtitle {
    // font-weight: 450;
    font-weight: 700;
    // font-size: 24px;
    font-size: 2.4rem;
    line-height: 34px;
    letter-spacing: 1.5px;
    text-transform: ${textTransform};
  }

  .cinema-rent__carousel-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 36px;

    .cinema-rent__carousel {
      width: 952px;
      height: 360px;

      .cinema-rent__carousel-image {
        width: 100%;
        height: 100%;
      }
    }
  }

  .cinema-rent__description {
    margin-top: 19px;
  }

  .cinema-rent__faq-wrapper {
    margin-top: 35px;

    h2 {
      font-weight: 450;
      font-size: 20px;
      line-height: 24px;
      letter-spacing: 1px;
      text-align: start;
    }

    .cinema-rent__faq-container {
      display: grid;
      grid-template-columns: repeat(3, 382px);
      grid-column-gap: 30px;
      grid-row-gap: 30px;
      margin-top: 52px;
      // grid-auto-rows: 1fr;

      .cinema-rent__faq-item {
        width: 100%;
        .cinema-rent__faq-item-image {
          // width: 304px;
          width: 100%;
          height: 171px;
        }

        .cinema-rent__faq-content-wrapper {
          position: relative;
          background: #2D2D2D;
          // height: calc(100% - ${({ isExpanded }) => (isExpanded ? '235px' : '171px')});
          padding: 7px 10px;
          // height: 60px;
          h2 {
            font-weight: 450;
            font-size: 20px;
            line-height: 22px;
            letter-spacing: 1.5px;
            text-transform: ${textTransform};
          }

          .cinema-rent__faq-content-accordion {
            position: absolute;
            right: 0;
            bottom: 0;
          }
        }

        .cinema-rent__faq-item-expand-content {
          margin: 10px 0;
          text-align:start;  
          font-size: 18px;
        }
      }
    }
  }

  .cinema-rent__giftcards-wrapper {
    margin-top: 67px;
    h2 {
      font-weight: 450;
      font-size: 20px;
      line-height: 24px;
      letter-spacing: 1px;
    }

    .cinema-rent__giftcards-container {
      margin-top: 12px;
      .cinema-rent__giftcard-content-wrapper {
        background: #2D2D2D;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 0 0 34px;

        h2 {
          font-weight: 450;
          font-size: 20px;
          line-height: 22px;
          letter-spacing: 1.5px;
          text-transform: uppercase;
        }
      }

      .cinema-rent__giftcards-expand-content {
        margin: 10px 0;
      }
      .cinema-rent__giftcards-expand-content a {
        color: #de1619;
        text-decoration:underline;
      }
    }
  }

  .cinema-rent__partners-wrapper {
    margin-top: 77px;
    h2 {
      font-weight: 450;
      font-size: 20px;
      line-height: 24px;
      letter-spacing: 1px;
      margin-bottom: 12px;
    }
  }

  .cinema-rent__divider {
    margin-top: 51px;
    border: 1px solid rgba(151, 151, 151, 0.8);
  }

  .cinema-rent__inquiry-wrapper {
    margin-top: 50px;
    display: flex;
    justify-content: space-between;

    h2 {
      font-weight: 450;
      font-size: 20px;
      line-height: 24px;
      letter-spacing: 1px;
    }
    .cinema-rent__inquiry-content {
      width: 100%;
      h3 {
        font-weight: 390;
        font-size: 16px;
        line-height: 24px;
      }
      .cinema-rent__inquiry-address-wrapper {
        margin-top: 30px;

        .cinema-rent__inquiry-title {
          font-weight: 450;
          font-size: 16px;
          line-height: 24px;
        }
      }

      .cinema-rent__inquiry-contact-wrapper {
        margin-top: 40px;
        .cinema-rent__inquiry-contact-red-link {
          color:#DE1619;
          text-decoration: underline;   
          cursor:pointer       
        }
        .cinema-rent__inquiry-contact-inquiry-btn {
          margin-top: 18px;
        }
        .cinema-rent__inquiry-contact-terms {
          margin: 15px 0;
          font-weight: 450;
          text-decoration: underline;
          color: #de1619;
        }
      }
    }

    .cinema-rent__newsletter-content {
      h3 {
        font-weight: 390;
        font-size: 16px;
        line-height: 24px;
        margin-top: 30px;
      }

      .cinema-rent__newsletter-content-btn {
        margin-top: 18px;
      }

      .cinema-rent__inquiry-contact-image-folder {
        font-weight: 450;
        text-decoration: underline;
        margin-top: 15px;
      }
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.breakPoints.sm.width}) {
    .cinema-rent__carousel-wrapper {
      width: 100%;
      .cinema-rent__carousel {
        width: 100%;
        height: 230px;
      }
    }    

    .cinema-rent__faq-wrapper {
      .cinema-rent__faq-container {
        grid-template-columns: 1fr;

        .cinema-rent__faq-item {
          .cinema-rent__faq-item-image {
            width: 100%;
            height: 200px;
          }
          .cinema-rent__faq-item-expand-content {
            /* margin */
          }
        }
      }
    }

    .cinema-rent__inquiry-wrapper {
      flex-direction: column;

      .cinema-rent__newsletter-content {
        margin: 25px 0;
      }
    }
  }
`;

export const FaqItem = styled.div`
  display: block;
`;

export const Expander = styled(VendorExpander)`
  background: #2d2d2d;
  padding: 0 9px;

  ul {
    & > li {
      width: 100%;
      display: list-item;
      margin-top: 12px;
      display: flex;
      align-items: flex-start;
    }
    & > li:first-child {
      margin-top: 0;
    }
    & > li:before {
      content: '';
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      padding: 5px;
      margin-right: 8px;
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 78.369 78.369'%3E%3Cpath fill='%23de1619' d='M78.049 19.015L29.458 67.606a1.094 1.094 0 0 1-1.548 0L.32 40.015a1.094 1.094 0 0 1 0-1.547l6.704-6.704a1.095 1.095 0 0 1 1.548 0l20.113 20.112 41.113-41.113a1.095 1.095 0 0 1 1.548 0l6.703 6.704a1.094 1.094 0 0 1 0 1.548z'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-origin: content-box;
    }
  }
`;

export const GiftcardExpander = styled(VendorExpander)`
  background: #2d2d2d;
  padding: 0 10px 0 34px;

  ul {
    & > li {
      width: 100%;
      display: list-item;
      list-style: disc;
      margin-top: 12px;
      display: flex;
      align-items: flex-start;
    }

    & > li:before {
      content: '';
      flex-shrink: 0;
      width: 24px;
      height: 24px;
      padding: 5px;
      margin-right: 8px;
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 78.369 78.369'%3E%3Cpath fill='%23de1619' d='M78.049 19.015L29.458 67.606a1.094 1.094 0 0 1-1.548 0L.32 40.015a1.094 1.094 0 0 1 0-1.547l6.704-6.704a1.095 1.095 0 0 1 1.548 0l20.113 20.112 41.113-41.113a1.095 1.095 0 0 1 1.548 0l6.703 6.704a1.094 1.094 0 0 1 0 1.548z'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-origin: content-box;
    }
  }
`;

export const Title = styled.h1`
  display: inline-block;
  vertical-align: middle;
  // font-weight: 450;
  font-weight: 700;
  // font-size: 24px;
  font-size:2.4rem;
  line-height: 34px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.color.textPrimary};
  margin: 24px 0 16px 0;
`;
